(ns manage.ad-variant.creation.feed.mapping.incomplete-mapping-modal
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["src/svg/inform/error-triangle-fill.svg$default" :as AlertIcon]
            [common.modal.view :refer [defmodal modal-v2]]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [uix.core :refer [$]]))

(defmodal placeholders-are-not-mapped :ad-variant/placeholders-are-not-mapped
  [{:keys [on-confirm]}]
  ($ modal-v2
     {:title "Incomplete mapping"
      :icon ($ SvgIcon {:color "warning"}
               ($ AlertIcon))
      :footer ($ Stack {:direction "row" :gap 1}
                 ($ Button {:variant "text"
                            :sx #js {:color "text.primary"}
                            :onClick #(do (rf/dispatch [:modal/close])
                                          (rfe/set-query (fn [q] (assoc q :tab :feed))))}
                    "Back to Placeholder Mapping")
                 ($ Button {:variant "contained"
                            :color "warning"
                            :onClick #(do (rf/dispatch [:modal/close])
                                          (on-confirm))}
                    "Continue Anyway"))}
     ($ Stack
        ($ :span "It looks like you haven't mapped all the placeholders in your template to your feed.")
        ($ :span "This may cause issues when rendering your final ad variants.")
        ($ :span "We recommend you complete the mapping before moving on."))))
